import {Component, OnInit} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {IAppState} from '../../store/state/app.state';

import {UserService} from '../../Services/User/user.service';
import {Router} from '@angular/router';
import {
  getAllCompanyEmployesByRolesError,
  getAllCompanyEmployesByRolesSuccess,
  getRoleUserError,
  getRoleUserSuccess,
  setCompanyEmployeesErrorMsg
} from '../../store/selectors/companyEmployee.selector';
import {
  GetEmployeesByRole,
  LoginCompanyEmployeeSuccess,
  SetCompanyEmployeesErrorMsg
} from '../../store/actions/companyEmployee.action';
import {Observable, Subscription} from 'rxjs';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {map} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {AddonService} from '../../Services/Addon/addon.service';


@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit {

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map((result: any) => result.matches)
    );
  userDetails: any;
  userRoleDetails: any;
  userTasks: any;
  name: string;
  company_name: string;
  show = false;
  options: any;
  successSubsribe: Subscription = new Subscription();
  errorSubscribe: Subscription = new Subscription();
  manageUserErrorSubscriber: Subscription = new Subscription();
  manageUserSuccessSubscriber: Subscription = new Subscription();
  userDetailsId = [];
  getRoles = [];
  selectedItem: any;
  connectionsOn = false; // S237 P493: role 9 Connections Controller only when the add-on is on

  constructor(public store: Store<IAppState>,
              public userService: UserService,
              private router: Router,
              private breakpointObserver: BreakpointObserver,
              private  dialog: MatDialog,
              private addonService: AddonService) {
  }

  ngOnInit() {
    this.name = this.userService.getUserdetails().name;
    this.company_name = this.userService.getUserdetails().CompanyUser.company_id.company_name;
    this.userDetails = this.userService.getUserdetails();
    this.userRoleDetails = this.userService.getUserRoleDetails();
    this.userService.selectedGrpObservable.subscribe(res => {
      this.selectedItem = res;
      // console.log(this.selectedItem)
      // console.log(this.userService.getUserdetails().id);
    });

    if (!!this.userRoleDetails) {
      this.options = this.userRoleDetails.CompanyUser.company_user_role.map(role => {
        return {
          role_name: role.role_data[0].role_id.role_name,
          role_id: role.role_data[0].role_id.id
        };
      });

      this.userTasks = this.userRoleDetails.CompanyUser.company_user_role.map(role => {
        return role.role_data[0].tasks.map(task => task);
      });
      this.userTasks = this.userTasks.flat();
      this.getSubscribeCompanyEmployee();
      this.getUserDetailsId();
      this.getUpdatedUserRoleDetails();

    } else if (!!this.userDetails) {
      this.options = this.userDetails.CompanyUser.company_user_role.map(role => {
        return {
          role_name: role.role_data[0].role_id.role_name,
          role_id: role.role_data[0].role_id.id
        };
      });
       console.log(this.options)
      this.userTasks = this.userDetails.CompanyUser.company_user_role.map(role => {
        return role.role_data[0].tasks.map(task => task);
      });
      this.userTasks = this.userTasks.flat();
      this.getSubscribeCompanyEmployee();
      this.getUserDetailsId();
      this.getUpdatedUserRoleDetails();
    }

    this.getEmployeesByRoles();
    this.addonService.mine().subscribe(keys => {
      this.connectionsOn = keys.includes('connections');
      // S238: a remembered Connections Controller role (9), hidden because the add-on is off, left the
      // role box blank and home showing only Support - fall back to the first role still shown.
      const shown = this.menuOptions();
      if (this.selectedItem != null && Number(this.selectedItem) === 9 && !this.connectionsOn && shown.length > 0) {
        this.getSelectChangeHandler(shown[0].role_id);
      }
    });
  }

  // S237 P493: the left menu and the role dropdown hide Connections Controller (role 9) unless the add-on is on
  menuOptions() {
    return (this.options || []).filter(o => o.role_id !== 9 || this.connectionsOn);
  }

  getSelectChangeHandler(data) {
    this.router.navigate(['./AdminHome']);
    localStorage.setItem('selectedController', data);
    this.userService.selectChangeHandler(data);
  }

  getUserDetailsId() {
    this.userDetailsId = [];
    this.userTasks.forEach(element => {
      if (!this.userDetailsId.includes(element.role_task_id.role_id)) {
        this.userDetailsId.push(element.role_task_id.role_id);
        this.userDetailsId.sort();
      }
    });
  }

  getUpdatedUserRoleDetails() {
    // this.store.dispatch(new GetUpdatedRoleUser({'id':this.userService.getUserdetails().id}))
    this.successSubsribe = this.store.pipe(select(getRoleUserSuccess)).subscribe((result: any) => {
      if (!!result) {
        this.userDetails = result;
        this.options = this.userDetails.CompanyUser.company_user_role.map(role => {
          return {
            role_name: role.role_data[0].role_id.role_name,
            role_id: role.role_data[0].role_id.id
          };
        });
        // console.log(this.options)
      }
    });
    this.errorSubscribe = this.store.pipe(select(getRoleUserError)).subscribe((result: any) => {
      if (!!result) {
        //  console.log(result)
        console.log(result);
        //alert(result.message);
      }
    });
  }


  getEmployeesByRoles() {
    const obj = {
      company_id: this.userService.getUserdetails().CompanyUser.company_id.id
    };

    this.manageUserSuccessSubscriber.unsubscribe();
    this.manageUserErrorSubscriber.unsubscribe();
    this.store.dispatch(new GetEmployeesByRole(obj));
    this.manageUserSuccessSubscriber = this.store.pipe(select(getAllCompanyEmployesByRolesSuccess)).subscribe((response: any) => {
      if (!!response) {
        this.userService.getEmployeesByRoles(response);
      }
    });
    this.manageUserErrorSubscriber = this.store.pipe(select(getAllCompanyEmployesByRolesError)).subscribe((response: any) => {
      if (!!response) {
        console.log(response);
      }
      // alert(response)
    });
  }

  logout() {
    const confirm_action = confirm(`Are you sure to Logout?`);
    if (confirm_action == true) {
      this.router.navigate(['login'], {replaceUrl: true});
      this.userService.destroyRoleUserdetails();
      this.userService.destroyUserdetails();
      this.store.dispatch(new LoginCompanyEmployeeSuccess(null));
    }
  }

  // getUpdatedUserRoleDetails(){
  //    this.store.dispatch(new GetUpdatedRoleUser({'id':this.userService.getUserdetails().id}))
  //    this.store.pipe(select(getRoleUserSuccess)).subscribe((result:any) => {
  //      if(!!result){
  //        //console.log(result)
  //       this.userDetails = result
  //       this.userDetails =  this.userService.getUserRoleDetails()
  //      }
  //    })
  //    this.store.pipe(select(getRoleUserError)).subscribe((result:any) => {
  //     if(!!result){
  //       // console.log(result)
  //       alert(result.error)
  //       this.store.dispatch(new GetUpdatedRoleUserError(null))
  //     }
  //   })
  // }

  getSubscribeMLO() {
    // this.store.pipe(select(getMLOSuccessMsg)).subscribe((result : any) => {
    //   if(!!result)
    //   console.log(result)
    // })
    // this.store.pipe(select(getMLOErrorMsg)).subscribe((result : any) => {
    //   if(!!result){
    //     alert(result.error)
    //     this.store.dispatch(new SetMLOError(null))
    //   }
    // })
  }

  getSubscribeSO() {
    // this.store.pipe(select(getSOErrorMsg)).subscribe((result : any) => {
    //   if(!!result && !!result.data){
    //     console.log(result.data)
    //     alert(`${result.from} is ${result.data.error}` )
    //     this.store.dispatch(new SetSOError(null, null))
    //   }
    // })

  }

  getSubscribeCustomer() {
    // this.store.pipe(select(getCustomerSuccess)).subscribe((result : any) => {
    //   if(!!result)
    //   console.log(result)
    // })
    // this.store.pipe(select(getAllCustomerError)).subscribe((result : any) => {
    //   if(!!result && !!result.data){
    //     alert(`${result.from} is ${result.data.error}` )
    //     this.store.dispatch(new GetAllCustomerError(null, null))
    //   }
    // })
  }

  getSubscribeCompanyEmployee() {
    this.store.pipe(select(setCompanyEmployeesErrorMsg)).subscribe((result: any) => {
      if (!!result) {
        // console.log(result)
        this.store.dispatch(new SetCompanyEmployeesErrorMsg(null));
      }
    });
  }

  ngOnDestroy() {
    this.successSubsribe.unsubscribe();
    this.errorSubscribe.unsubscribe();
  }

}
